const MODELO_SQL = `
{
  "user": "",
  "password": "",
  "server": "",
  "database": ""
}
`

const MODELO_ORACLE = `
{
  "user": "",
  "password": "",
  "connectString": "endereco_url:numero_porta/prd_sml:DEDICATED",
  "poolIncrement": 0,
  "poolMax": 8,
  "poolMin": 8
}
`

const MODELO_FIREBIRD = `
{
  "host": "",
  "port": numero,
  "database": "",
  "user": "sysdba",
  "password": "masterkey",
  "retryConnectionInterval": 10000,
  "encoding": "UTF8"
}
`

const MODELO_MYSQL = `
{
  "user": "",
  "password": "",
  "database": "",
  "host": "",
  "decimalNumbers": true,
  "port": 3306,
  "timezone": "-03:00",
  "charset" : "utf8",
  "pool": {
    "max": 5,
    "min": 0,
    "acquire": 90000,
    "idle": 10000
  }
}
`

// Tipos de Conexao
export interface TipoConexaoInterface {
  idTipoConexao: string
  descricao: string
  modeloConexao: string
}

export enum TipoConexaoType {
  SEM_CONEXAO = '',
  SQLSERVER = 'SQLSERVER',
  ORACLE = 'ORACLE',
  FIREBIRD = 'FIREBIRD',
  MYSQL = 'MYSQL'
}

export const TipoConexaoTypes: Array<TipoConexaoInterface> = [
  { idTipoConexao: TipoConexaoType.SQLSERVER, descricao: 'SQL Server', modeloConexao: MODELO_SQL },
  { idTipoConexao: TipoConexaoType.ORACLE, descricao: 'Oracle', modeloConexao: MODELO_ORACLE },
  { idTipoConexao: TipoConexaoType.FIREBIRD, descricao: 'Firebird', modeloConexao: MODELO_FIREBIRD },
  { idTipoConexao: TipoConexaoType.MYSQL, descricao: 'MySQL', modeloConexao: MODELO_MYSQL }
]

// Tipo de Sistema de ERP
export interface TipoERPInterface {
  idTipoERP: string
  descricao: string
  idTipoConexao: string
}

export enum TipoERPType {
  SEM_ACESSO = 'Sem Acesso',
  MV = 'MV',
  SPData = 'SPData'
}

export const TipoERPTypes: Array<TipoERPInterface> = [
  { idTipoERP: TipoERPType.SEM_ACESSO, descricao: 'Sem Acesso', idTipoConexao: TipoConexaoType.SEM_CONEXAO },
  { idTipoERP: TipoERPType.MV, descricao: 'MV', idTipoConexao: TipoConexaoType.ORACLE },
  { idTipoERP: TipoERPType.SPData, descricao: 'SPData', idTipoConexao: TipoConexaoType.FIREBIRD }
]

// Tipo de Sistema de RH
export interface TipoRHInterface {
  idTipoRH: string
  descricao: string
  idTipoConexao: string
}

export enum TipoRHType {
  SEM_ACESSO = 'Sem Acesso',
  TOTVS = 'TOTVS',
  SPData = 'SPData'
}

export const TipoRHTypes: Array<TipoRHInterface> = [
  { idTipoRH: TipoRHType.SEM_ACESSO, descricao: 'Sem Acesso', idTipoConexao: TipoConexaoType.SEM_CONEXAO },
  { idTipoRH: TipoRHType.TOTVS, descricao: 'TOTVS', idTipoConexao: TipoConexaoType.SQLSERVER },
  { idTipoRH: TipoRHType.SPData, descricao: 'SPData', idTipoConexao: TipoConexaoType.FIREBIRD }
]

// Tipo de Sistema de OS
export interface TipoOSInterface {
  idTipoOS: string
  descricao: string
  idTipoConexao: string
}

export enum TipoOSType {
  SEM_ACESSO = 'Sem Acesso',
  MV = 'MV',
  SPData = 'SPData'
}

export const TipoOSTypes: Array<TipoOSInterface> = [
  { idTipoOS: TipoOSType.SEM_ACESSO, descricao: 'Sem Acesso', idTipoConexao: TipoConexaoType.SEM_CONEXAO },
  { idTipoOS: TipoOSType.MV, descricao: 'MV', idTipoConexao: TipoConexaoType.ORACLE },
  { idTipoOS: TipoOSType.SPData, descricao: 'SPData', idTipoConexao: TipoConexaoType.FIREBIRD }
]

// Tipo Notificacoes
export interface CanalNotificacaoTypesInterface {
  idCanal: string
  descricao: string
}

export enum CanalNotificacaoType {
  WHATSAPP = 'WA',
  EMAIL = 'EM',
  TELEFONE = 'FO'
}

export const CanalNotificacaoTypes: Array<CanalNotificacaoTypesInterface> = [
  { idCanal: CanalNotificacaoType.WHATSAPP, descricao: 'Whats APP' },
  { idCanal: CanalNotificacaoType.EMAIL, descricao: 'e-mail' },
  { idCanal: CanalNotificacaoType.TELEFONE, descricao: 'Fone' }
]

// export const VALIDACAO_MASCARA: RegExp = /^((\.[9]+)|([9]+(\.[9]+)?))$/

// export const VALIDACAO_NOME_VARAIVEL: RegExp = /^[A-Z_][0-9A-Z_]*$/

// Tipo Notificacoes
export interface FilialTypesInterface {
  idFilial: string
  descricao: string
  cCodCateg: string
  nCodCC: number
  cCodCategItem: string
  cCodServLC116: string
  cCodServMun: string
  cTribServ: string
  nCodServico: number
}

export enum FilialType {
  UNITHAL_CAMPINAS = 'UNITHAL_CAMPINAS',
  MARINGA = 'MARINGA',
  PATOS = 'PATOS'
}

export const FilialTypes: Array<FilialTypesInterface> = [
  {
    idFilial: FilialType.PATOS,
    descricao: 'PATOS DE MINAS (MG)',
    cCodCateg: "1.01.02",
    nCodCC: 6335512948,
    cCodCategItem: "1.01.02",
    cCodServLC116: "17.01",
    cCodServMun: "1701",
    cTribServ: "G3",
    nCodServico: 6341030410
  },
  {
    idFilial: FilialType.UNITHAL_CAMPINAS,
    descricao: 'CAMPINAS (SP)',
    cCodCateg: "1.01.02",
    nCodCC: 10918596068,
    cCodCategItem: "1.01.02",
    cCodServLC116: "17.09",
    cCodServMun: "7120-1/00-00",
    cTribServ: "16",
    nCodServico: 10937575873
  },
  {
    idFilial: FilialType.MARINGA,
    descricao: 'MARINGA (PR)',
    cCodCateg: "1.01.02",
    nCodCC: 2580330726,
    cCodCategItem: "1.01.02",
    cCodServLC116: "17.01",
    cCodServMun: "170102",
    cTribServ: "01",
    nCodServico: 2580325093
  }
]